import { Box } from 'ink';
import CustomSelectInputIndicator from './CustomSelectInputIndicator';
import SelectInput, {
  type IndicatorProps,
  type Item,
  type ItemProps,
} from './SelectInput';
import TableEnd from './table/TableEnd';
import TableHead from './table/TableHead';
import TableRow from './table/TableRow';
import getKeyDetails from './table/getKeyDetails';
import { DataItem } from './table/tableTypes';

export type { Item } from './SelectInput';

/*
  This is like if <Table/> and ink-select-input had a baby.
  Read the block comment at the top of <Table/> first.
*/
export default function SelectTable<T extends DataItem = DataItem>({
  data,
  onSelect,
}: {
  data: T[];
  onSelect?: (item: Item<T>) => void;
}) {
  const keyDetails = getKeyDetails(data);

  const getSelectItems = (): Item<T>[] => {
    return data.map((rowData, index) => {
      return {
        index,
        key: index.toString(),
        label: '',
        value: rowData,
      };
    });
  };

  function ItemComponent({ index, isSelected }: ItemProps) {
    return (
      <TableRow
        data={data[index as number]}
        key={index}
        keyDetails={keyDetails}
        textProps={{ bold: isSelected, color: isSelected ? undefined : 'gray' }}
      />
    );
  }

  return (
    <Box flexDirection="column">
      <TableHead keyDetails={keyDetails} marginLeft={2} />
      <SelectInput
        indicatorComponent={CustomIndicator}
        itemComponent={ItemComponent}
        items={getSelectItems()}
        onSelect={onSelect}
      />
      <TableEnd keyDetails={keyDetails} marginLeft={2} />
    </Box>
  );
}

function CustomIndicator(props: IndicatorProps) {
  return <CustomSelectInputIndicator marginTop={1} {...props} />;
}
